const LVSpayNeuterLight = () => (
	<>
		<path
			d="M7.71925 3.84545L3.84446 7.72024C3.06344 8.50126 3.06344 9.76754 3.84446 10.5486L21.4366 28.1407C22.2176 28.9217 23.4839 28.9217 24.2649 28.1407L28.1397 24.2659C28.9207 23.4849 28.9207 22.2186 28.1397 21.4376L10.5476 3.84545C9.76654 3.06443 8.50026 3.06443 7.71925 3.84545Z"
			fill="#2CA757"
		/>
		<path
			d="M28.154 7.73271L24.2792 3.85791C23.4982 3.0769 22.2319 3.0769 21.4509 3.85791L3.85877 21.45C3.07775 22.2311 3.07775 23.4973 3.85877 24.2784L7.73356 28.1531C8.51458 28.9342 9.78086 28.9342 10.5619 28.1531L28.154 10.561C28.935 9.78 28.935 8.51372 28.154 7.73271Z"
			fill="white"
		/>
		<path
			d="M16.0067 14.5803C15.9069 14.5803 15.8071 14.5419 15.7303 14.4651C15.5767 14.3116 15.5767 14.0659 15.7303 13.92C15.8071 13.8432 15.8992 13.8048 16.0067 13.8048C16.1142 13.8048 16.2063 13.8432 16.2831 13.92C16.4366 14.0736 16.4366 14.3192 16.2831 14.4651C16.2063 14.5419 16.1142 14.5803 16.0067 14.5803Z"
			fill="#2CA757"
		/>
		<path
			d="M16.0069 13.4211C15.8073 13.4211 15.6154 13.4979 15.4618 13.6437C15.1624 13.9432 15.1624 14.4345 15.4618 14.7339C15.6154 14.8875 15.8073 14.9566 16.0069 14.9566C16.2065 14.9566 16.3985 14.8798 16.552 14.7339C16.8514 14.4345 16.8514 13.9432 16.552 13.6437C16.3985 13.4902 16.2065 13.4211 16.0069 13.4211Z"
			fill="#00084D"
		/>
		<path
			d="M17.8104 16.3844C17.7106 16.3844 17.6108 16.346 17.534 16.2692C17.3804 16.1157 17.3804 15.87 17.534 15.7241C17.6108 15.6473 17.7029 15.6089 17.8104 15.6089C17.9179 15.6089 18.01 15.6473 18.0868 15.7241C18.2403 15.8777 18.2403 16.1233 18.0868 16.2692C18.01 16.346 17.9179 16.3844 17.8104 16.3844Z"
			fill="#2CA757"
		/>
		<path
			d="M17.8106 15.225C17.611 15.225 17.419 15.3018 17.2655 15.4476C16.966 15.747 16.966 16.2384 17.2655 16.5378C17.419 16.6914 17.611 16.7605 17.8106 16.7605C18.0102 16.7605 18.2021 16.6837 18.3557 16.5378C18.6551 16.2384 18.6551 15.747 18.3557 15.4476C18.2021 15.2941 18.0102 15.225 17.8106 15.225Z"
			fill="#00084D"
		/>
		<path
			d="M14.1493 16.4378C14.0495 16.4378 13.9497 16.3994 13.8729 16.3227C13.7194 16.1691 13.7194 15.9234 13.8729 15.7775C13.9497 15.7008 14.0418 15.6624 14.1493 15.6624C14.2568 15.6624 14.3489 15.7008 14.4257 15.7775C14.5792 15.9311 14.5792 16.1768 14.4257 16.3227C14.3489 16.3994 14.2568 16.4378 14.1493 16.4378Z"
			fill="#2CA757"
		/>
		<path
			d="M14.1496 15.2785C13.9499 15.2785 13.758 15.3553 13.6045 15.5012C13.305 15.8006 13.305 16.2919 13.6045 16.5914C13.758 16.7449 13.9499 16.814 14.1496 16.814C14.3492 16.814 14.5411 16.7372 14.6947 16.5914C14.9941 16.2919 14.9941 15.8006 14.6947 15.5012C14.5411 15.3476 14.3492 15.2785 14.1496 15.2785Z"
			fill="#00084D"
		/>
		<path
			d="M15.953 18.2419C15.8531 18.2419 15.7533 18.2035 15.6766 18.1267C15.523 17.9731 15.523 17.7275 15.6766 17.5816C15.7533 17.5048 15.8455 17.4664 15.953 17.4664C16.0604 17.4664 16.1526 17.5048 16.2293 17.5816C16.3829 17.7351 16.3829 17.9808 16.2293 18.1267C16.1526 18.2035 16.0604 18.2419 15.953 18.2419Z"
			fill="#2CA757"
		/>
		<path
			d="M15.9531 17.0825C15.7535 17.0825 15.5615 17.1592 15.408 17.3051C15.1086 17.6045 15.1086 18.0959 15.408 18.3953C15.5615 18.5489 15.7535 18.618 15.9531 18.618C16.1527 18.618 16.3446 18.5412 16.4982 18.3953C16.7976 18.0959 16.7976 17.6045 16.4982 17.3051C16.3446 17.1516 16.1527 17.0825 15.9531 17.0825Z"
			fill="#00084D"
		/>
		<path
			d="M17.525 10.3546L21.6449 14.4744"
			stroke="#00084D"
			strokeWidth="0.74997"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
		<path
			d="M10.6853 17.2044L14.8051 21.3242"
			stroke="#00084D"
			strokeWidth="0.74997"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
	</>
);

export default LVSpayNeuterLight;
